<page-loader *ngIf="isLoading"></page-loader>
<div id="page-org-view" class="page-section series-form-page" *ngIf="!isLoading">
	<div class="app-l-page__navigation">
		<div class="app-l-page__previous" [routerLink]="['/admin/organization-listing']">
			<button class="app-c-btn app-c-btn--icon app-c-btn--icon-secondary app-c-btn--icon-20">
				<svg-icon icon="arrow-left" class="w-100 h-100"></svg-icon>
			</button>
		</div>
		<div class="app-l-page__breadcrumbs">
			<ul class="breadcrumbs-list">
				<li class="breadcrumbs-list-item">
					<a [routerLink]="['/admin/organization-listing']">Organizations</a>
				</li>
				<li class="breadcrumbs-list-item app-l-current-page">
					{{ organization.name }}
				</li>
			</ul>
		</div>
	</div>

	<div class="page-section-content">
		<div class="org-header" *ngIf="(organization | json) !== '{}'">
			<div class="org-header-top">
				<h1>{{ organization.name }}</h1>
				<button class="app-c-btn app-c-btn--primary app-c-btn--curve"
					(click)="editOrganization()">Edit Organization</button>
			</div>
			<div class="org-header-links">
				<div class="org-link-item" *ngIf="subdomainlink">
					<span class="org-link-label">Subdomain link</span>
					<span class="org-link-value">{{ subdomainlink }}</span>
				</div>
				<div class="org-link-item" *ngIf="accesscodelink">
					<span class="org-link-label">Access code link</span>
					<span class="org-link-value">{{ accesscodelink }}</span>
				</div>
			</div>
		</div>

		<my-tabs>
			<!-- Stats Tab -->
			<my-tab tabTitle="Stats">
				<dashboard-executive [showTitle]="false" [orgId]="id"></dashboard-executive>
			</my-tab>

			<!-- Activity Tab — hidden until the listing is reimplemented; reports were inconsistent vs Power BI -->
			<my-tab tabTitle="Activity" *ngIf="false">
				<activity-listing
					[orgId]="id"
					[isActivityTabEnabled]="isActivityTabEnabled"></activity-listing>
			</my-tab>

			<!-- Members Tab -->
			<my-tab tabTitle="Members">
				<!-- Executive Professionals -->
				<div class="member-section">
					<div class="member-section-header">
						<h3 translate>organizationListing.executiveprofessional</h3>
						<button class="app-c-btn app-c-btn--primary app-c-btn--curve"
							(click)="showInvite('executiveprofessional')">Invite</button>
					</div>
					<div class="table-responsive">
						<table class="user-table">
							<thead>
								<tr>
									<th translate>userListing.headers.0</th>
									<th translate>userListing.headers.1</th>
									<th translate>userListing.headers.2</th>
									<th translate>userListing.headers.3</th>
									<th class="actions-col"></th>
								</tr>
							</thead>
							<tbody>
								<tr *ngFor="let ep of executiveprofessionals">
									<td>{{ ep?.fullName }}</td>
									<td>{{ ep?.loginOn | date: 'MM/dd/yy' }}</td>
									<td>{{ ep?.email }}</td>
									<td>{{ ep?.primaryOrganization?.name || '' }}</td>
									<td class="actions-col">
										<a [routerLink]="['/admin/user', ep.id]"
											class="app-c-btn app-c-btn--icon app-c-btn--icon-secondary app-c-btn--icon-20"
											title="View">
											<svg-icon icon="eye-icon" class="w-100 h-100"></svg-icon>
										</a>
									</td>
								</tr>
							</tbody>
						</table>
						<p *ngIf="!executiveprofessionals || executiveprofessionals.length < 1"
							translate class="empty-state">organizationView.noUsersfound</p>
					</div>
				</div>

				<!-- Executives -->
				<div class="member-section">
					<div class="member-section-header">
						<h3 translate>organizationListing.executive</h3>
						<button class="app-c-btn app-c-btn--primary app-c-btn--curve"
							(click)="showInvite('executive')">Invite</button>
					</div>
					<div class="table-responsive">
						<table class="user-table">
							<thead>
								<tr>
									<th translate>userListing.headers.0</th>
									<th translate>userListing.headers.1</th>
									<th translate>userListing.headers.2</th>
									<th translate>userListing.headers.3</th>
									<th class="actions-col"></th>
								</tr>
							</thead>
							<tbody>
								<tr *ngFor="let executive of executives">
									<td>{{ executive?.fullName }}</td>
									<td>{{ executive?.loginOn | date: 'MM/dd/yy' }}</td>
									<td>{{ executive?.email }}</td>
									<td>{{ executive?.primaryOrganization?.name }}</td>
									<td class="actions-col">
										<a [routerLink]="['/admin/user', executive.id]"
											class="app-c-btn app-c-btn--icon app-c-btn--icon-secondary app-c-btn--icon-20"
											title="View">
											<svg-icon icon="eye-icon" class="w-100 h-100"></svg-icon>
										</a>
									</td>
								</tr>
							</tbody>
						</table>
						<p *ngIf="!executives || executives.length < 1"
							translate class="empty-state">organizationView.noUsersfound</p>
					</div>
				</div>

				<!-- Professionals -->
				<div class="member-section">
					<div class="member-section-header">
						<h3 translate>organizationListing.professional</h3>
						<button class="app-c-btn app-c-btn--primary app-c-btn--curve"
							(click)="showInvite('professional')">Invite</button>
					</div>
					<div class="table-responsive">
						<table class="user-table">
							<thead>
								<tr>
									<th translate>userListing.headers.0</th>
									<th translate>userListing.headers.1</th>
									<th translate>userListing.headers.2</th>
									<th translate>userListing.headers.3</th>
									<th class="actions-col"></th>
								</tr>
							</thead>
							<tbody>
								<tr *ngFor="let professional of professionals">
									<td>{{ professional?.fullName }}</td>
									<td>{{ professional?.loginOn | date: 'MM/dd/yy' }}</td>
									<td>{{ professional?.email }}</td>
									<td>{{ professional?.primaryOrganization?.name }}</td>
									<td class="actions-col">
										<a [routerLink]="['/admin/user', professional.id]"
											class="app-c-btn app-c-btn--icon app-c-btn--icon-secondary app-c-btn--icon-20"
											title="View">
											<svg-icon icon="eye-icon" class="w-100 h-100"></svg-icon>
										</a>
									</td>
								</tr>
							</tbody>
						</table>
						<p *ngIf="!professionals || professionals.length < 1"
							translate class="empty-state">organizationView.noUsersfound</p>
					</div>
				</div>

				<!-- Internal Users (Admin / Relationship Manager) -->
				<div class="member-section">
					<div class="member-section-header">
						<h3>Internal Users</h3>
					</div>
					<div class="table-responsive">
						<table class="user-table">
							<thead>
								<tr>
									<th translate>userListing.headers.0</th>
									<th translate>userListing.headers.1</th>
									<th translate>userListing.headers.2</th>
									<th translate>userListing.headers.3</th>
									<th class="actions-col"></th>
								</tr>
							</thead>
							<tbody>
								<tr *ngFor="let internalUser of internalUsers">
									<td>{{ internalUser?.fullName }}</td>
									<td>{{ internalUser?.loginOn | date: 'MM/dd/yy' }}</td>
									<td>{{ internalUser?.email }}</td>
									<td>{{ internalUser?.userType }}</td>
									<td class="actions-col">
										<a [routerLink]="['/admin/user', internalUser.id]"
											class="app-c-btn app-c-btn--icon app-c-btn--icon-secondary app-c-btn--icon-20"
											title="View">
											<svg-icon icon="eye-icon" class="w-100 h-100"></svg-icon>
										</a>
									</td>
								</tr>
							</tbody>
						</table>
						<p *ngIf="!internalUsers || internalUsers.length < 1"
							translate class="empty-state">organizationView.noUsersfound</p>
					</div>
				</div>

				<!-- Users -->
				<div class="member-section">
					<div class="member-section-header">
						<h3 translate>organizationListing.user</h3>
						<div class="member-section-actions">
							<button *ngIf="organization.demoStatus"
								class="app-c-btn app-c-btn--secondary app-c-btn--curve"
								(click)="createDemoUser()">Create demo user</button>
							<button class="app-c-btn app-c-btn--primary app-c-btn--curve"
								(click)="showInvite('user')">Invite</button>
						</div>
					</div>
					<div class="table-responsive">
						<table class="user-table">
							<thead>
								<tr>
									<th translate>userListing.headers.0</th>
									<th translate>userListing.headers.1</th>
									<th translate>userListing.headers.2</th>
									<th translate>userListing.headers.3</th>
									<th class="actions-col"></th>
								</tr>
							</thead>
							<tbody>
								<tr *ngFor="let userrow of users">
									<td>{{ userrow?.fullName }}</td>
									<td>{{ userrow?.loginOn | date: 'MM/dd/yy' }}</td>
									<td>{{ userrow?.email }}</td>
									<td>{{ userrow?.primaryOrganization?.name || '' }}</td>
									<td class="actions-col">
										<a [routerLink]="['/admin/user', userrow.id]"
											class="app-c-btn app-c-btn--icon app-c-btn--icon-secondary app-c-btn--icon-20"
											title="View">
											<svg-icon icon="eye-icon" class="w-100 h-100"></svg-icon>
										</a>
									</td>
								</tr>
							</tbody>
						</table>
						<p *ngIf="!users || users.length < 1"
							translate class="empty-state">organizationView.noUsersfound</p>
					</div>
				</div>
			</my-tab>

			<!-- Invites Tab -->
			<my-tab tabTitle="Invites">
				<div class="filter-bar">
					<div class="app-c-form-group">
						<label class="app-c-form--label">Filter by type</label>
						<select class="app-c-form-control" [(ngModel)]="selectedInviteType"
							(ngModelChange)="onTypeChange($event)">
							<option *ngFor="let type of userType" [value]="type.key">
								{{ type.name }}
							</option>
						</select>
					</div>
				</div>
				<div class="table-responsive">
					<table class="user-table">
						<thead>
							<tr>
								<th translate>userListing.headers.0</th>
								<th translate>userListing.headers.14</th>
								<th translate>userListing.headers.2</th>
								<th translate>userListing.headers.3</th>
								<th translate>userListing.headers.8</th>
								<th class="actions-col"></th>
							</tr>
						</thead>
						<tbody>
							<tr *ngFor="let invite of invites">
								<td>{{ invite.Name }}</td>
								<td>{{ invite.Role }}</td>
								<td>{{ invite.RecipientEmail }}</td>
								<td>{{ invite.OrganizationName }}</td>
								<td>
									<span class="status-badge"
										[ngClass]="{
											'status-active': invite.Status === 'accepted',
											'status-pending': invite.Status === 'pending',
											'status-disabled': invite.Status === 'expired' || invite.Status === 'rejected'
										}">
										{{ invite.Status | titlecase }}
									</span>
								</td>
								<td class="actions-col">
									<button
										class="app-c-btn app-c-btn--icon app-c-btn--icon-secondary app-c-btn--icon-20"
										title="Resend"
										(click)="doResend(invite.ID)">
										<svg-icon icon="mail-icon" class="w-100 h-100"></svg-icon>
									</button>
									<button
										class="app-c-btn app-c-btn--icon app-c-btn--icon-secondary app-c-btn--icon-20"
										title="Delete"
										(click)="doRemoveInvite(invite.ID)">
										<svg-icon icon="delete-button-icon" class="w-100 h-100"></svg-icon>
									</button>
								</td>
							</tr>
						</tbody>
					</table>
					<p *ngIf="!invites || invites.length < 1"
						translate class="empty-state">organizationView.noUsersfound</p>
				</div>
			</my-tab>

			<!-- Access Codes Tab -->
			<my-tab tabTitle="Access Codes">
				<div class="member-section-header">
					<h3>&nbsp;</h3>
					<button class="app-c-btn app-c-btn--primary app-c-btn--curve"
						(click)="createAccessCode()" translate>organizationView.code.button</button>
				</div>
				<div class="table-responsive">
					<table class="user-table">
						<thead>
							<tr>
								<th translate>organizationView.code.headers.0</th>
								<th class="actions-col" translate>organizationView.code.headers.1</th>
							</tr>
						</thead>
						<tbody>
							<tr *ngFor="let code of accesscodes; let i = index">
								<td>{{ code.Code }}</td>
								<td class="actions-col">
									<button
										class="app-c-btn app-c-btn--icon app-c-btn--icon-secondary app-c-btn--icon-20"
										title="Delete"
										(click)="onDeleteAccessCode(i)">
										<svg-icon icon="delete-button-icon" class="w-100 h-100"></svg-icon>
									</button>
								</td>
							</tr>
						</tbody>
					</table>
					<p *ngIf="!accesscodes || accesscodes.length < 1"
						translate class="empty-state">organizationView.noAccessCodesFound</p>
				</div>
			</my-tab>
		</my-tabs>
	</div>
</div>
